export const toCapitalAcronym = (input: string): string =>
  input
    .trim()
    .split(/\s+/)
    .map((word) => {
      const [firstChar] = word;

      return firstChar && /[A-Z]/.test(firstChar) ? firstChar : '';
    })
    .join('');
